// static class
import moment from 'moment';
import { Utils as NhstUtils } from '@nhst/nhst-sub-auth-services';

class Utils extends NhstUtils {
  static getAllowedFormatsForDates() {
    return [
      'DD.MM.YYYY',
      'YYYY-MM-DD',
      'DD-MM-YYYY'
    ];
  }

  static getDefaultDateFormat() {
    return 'DD.MM.YYYY';
  }

  static formatDate(date, format = '') {
    return moment(date).format(format || Utils.getAllowedFormatsForDates()[0]);
  }
}

export default Utils;
